import styled from 'styled-components';

export const SafeAreaView = styled.div`
  height: 100%;
  padding-top: ${({ $top }) => `${$top}px`};
  padding-bottom: ${({ $bottom }) => `${$bottom}px`};
`;

export const Content = styled.div`
  height: ${({ $hideLogo }) => ($hideLogo ? '100%' : 'calc(100% - 4.6rem)')};
  overflow: scroll;

  ${({ $hideScrollbar }) =>
    $hideScrollbar &&
    `
      scrollbar-width: none;

      &::-webkit-scrollbar {
        display: none;
      }
    `}
`;

export const Header = styled.div`
  height: 4.6rem;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    margin-top: 0.2rem;
  }
`;
